import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { vlnyController } from "../../../controllers/vlny.controller";

class ZoznamVln extends Component {
    lastSelectedIndex = 0;

    state = {
        items: [],
        loading: true,
        skip: 0,
        take: 25,
        selectedVlnaId: null
    };

    componentDidMount() {
        this.getZoznamVln();
    }

    getZoznamVln() {
        vlnyController.getZoznamVln().then(response => {
            let data = JSON.parse(JSON.stringify(response));

            if (data.errorMessage != null) {
                this.props.handleErrorMessage(data.errorMessage);
            } else {
                var selectedVlnaId = data.items[0] ? data.items[0].idVlna : null;
                if (data.items[0]) {
                    data.items[0].selected = true;
                }
                this.props.changeSelectedVlnaId(selectedVlnaId);
                this.props.changeSelectedVlnaIds(data.items.filter(dataItem => dataItem.selected).map(a => a.idVlna));

                this.setState({
                    items: data.items,
                    loading: false,
                    selectedVlnaId: selectedVlnaId
                });
            }
        });
    }

    changeSelectedVlnaId = e => {
        this.props.changeSelectedVlnaId(e.dataItem.idVlna);
        this.setState({
            selectedVlnaId: e.dataItem.idVlna
        });

        var items = this.state.items;
        let last = this.lastSelectedIndex;
        const current = items.findIndex(dataItem => dataItem === e.dataItem);

        if (!e.nativeEvent.shiftKey || !this.props.multiselect) {
            this.lastSelectedIndex = last = current;
        }

        if (!e.nativeEvent.ctrlKey || !this.props.multiselect) {
            items.forEach(item => (item.selected = false));
        }
        const select = !e.dataItem.selected;
        for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
            items[i].selected = select;
        }
        this.props.changeSelectedVlnaIds(items.filter(dataItem => dataItem.selected).map(a => a.idVlna));

        this.forceUpdate();
    };

    pageChange = event => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    };

    renderTable(items) {
        var localizationService = provideLocalizationService(this);

        return (
            <div id="ZoznamVln" onMouseDown={e => e.preventDefault() /* prevents browser text selection */}>
                <Grid
                    data={items.slice(this.state.skip, this.state.take + this.state.skip)}
                    skip={this.state.skip}
                    take={this.state.take}
                    total={items.length}
                    pageable={{ buttonCount: 5 }}
                    onPageChange={this.pageChange}
                    selectedField="selected"
                    onRowClick={this.changeSelectedVlnaId}>
                    <GridColumn field="vlna" title={localizationService.toLanguageString("Vlny.Grid.Vlna", "Vlna")} width="60px" />
                    <GridColumn field="artiklov" title={localizationService.toLanguageString("Vlny.Grid.Artiklov", "Artiklov")} width="100px" />
                    <GridColumn field="manipulace" title={localizationService.toLanguageString("Vlny.Grid.Spôsob manipulácie", "Spôsob manipulácie")} />
                    <GridColumn field="stav" title={localizationService.toLanguageString("Vlny.Grid.Stav ks", "Stav ks")} width="100px" />
                </Grid>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderTable(this.state.items);

        return <div>{contents}</div>;
    }
}

export default ZoznamVln;

registerForLocalization(ZoznamVln);



// WEBPACK FOOTER //
// ./src/components/dialogs/Vlny/ZoznamVln.js